// This is the entry point for a bundle for the theme OUTSIDE of the app - do not import this anywhere.
import './style.scss';
import domReady from '@wordpress/dom-ready';
import { getQueryArgs } from '@wordpress/url';
import { QueryClient } from '@tanstack/react-query';
import feature from 'lib/utils/feature';
import { getRedirectURL, getToken, setOauthData } from 'data/oauth/utils';

function initialize() {
	const queryClient = new QueryClient();

	window.convergence = {
		queryClient,
	};
}

function oauthRedirect() {
	if ( document.location.hash.includes('access_token=') ) {
		// @ts-expect-error The variable is injected by webpack.DefinePlugin.
		const params = getQueryArgs( `https://${HPP_ORIGIN}/?${document.location.hash.substring( 1 )}` );
		const t = new Date().getTime();
		const expiresIn = parseInt( params.expires_in.toString() );

		setOauthData( {
			accessToken: params.access_token.toString() || '',
			tokenType: params.token_type.toString() || '',
			scope: params.scope.toString() || '',
			siteId: parseInt( params.site_id.toString() ) || 0,
			expiresIn,
			expiresAt: new Date( t + ( expiresIn * 1000 ) )
		} );

		return window.location.replace( '/' );
	}

	const token = getToken();

	if ( ! token ) {
		return window.location.replace( getRedirectURL() );
	}
}

function boot() {
	if ( feature( 'block-theme/oauth' ) ) {
		initialize();
		oauthRedirect();
	}
}

domReady(() => {
	boot();
})
